import { useState, useEffect } from "react";
import img5 from '../assets/images/404 Error-bro.svg';

function GeneralInfo(){

    const [estado, setEstado] = useState(true)
    const [toggleState, setToggleState] = useState(0);
    const [num, setNum] = useState(18296735811)
    const [title, setTitle] = useState('ShaBless Accesorios & Mas')
    const [email, setEmail] = useState('negociosasmin24@gmail.com')
    const [description, setDescription] = useState("Mi tienda de accesorios es el lugar perfecto para aquellos que buscan complementar su estilo personal con productos únicos y de calidad. Ofrecemos una amplia variedad de accesorios, desde joyería, bolsos, sombreros, relojes, carteras y mucho más. Todos nuestros productos son seleccionados cuidadosamente para asegurar que cumplen con los altos estándares de calidad y estilo.")

    const cambio=(index)=>{
        estado===true?setEstado(false):setEstado(true)
    }

    let redes=[
        {
            nombre: 'Instagram',
            mostrar: true,
            url: 'https://instagram.com/shabless24?igshid=YmMyMTA2M2Y='
        },
        {
            nombre: 'Youtube',
            mostrar: false,
            url: 'https://www.linkedin.com/in/keury-lendof-599b82185/'
        },
        {
            nombre: 'Facebook',
            mostrar: false,
            url: 'https://www.linkedin.com/in/keury-lendof-599b82185/'
        },
        {
            nombre: 'Linkedin',
            mostrar: false,
            url: 'https://www.linkedin.com/in/keury-lendof-599b82185/'
        },
    ]

    useEffect(()=>{
        let telefono = document.getElementById('telefono'),
            correo = document.getElementById('correo'),
            titulo = document.getElementById('titulo'),
            descripcion = document.getElementById('description')
        ;
        telefono.value = num;
        titulo.value = title;
        correo.value = email;
        descripcion.value = description;
      }
    ,[])


    return (
        <>
            <div className='general-info-container'>

                <section>

                    <article className="header-general-info">
                        <h3>Datos Principales</h3>
                        <article className='editar' onClick={()=>cambio(1)}>
                            <i className={estado===true?"fa fa-edit":"fa fa-check checking"}></i>
                        </article>
                    </article>

                    <article className="input-line-general">
                        <label for="telefono">Telefono</label>
                        <input type='tel' name="telefono" id="telefono" placeholder="" disabled={estado}/>
                    </article>

                    <article className="input-line-general">
                        <label for="correo">Correo</label>
                        <input type='email' name="correo" id="correo" placeholder="" disabled={estado}/>
                    </article>

                    <article className="input-line-general">
                        <label for="titulo">Titulo Principal</label>
                        <input type='text' name="titulo" id="titulo" placeholder="" disabled={estado}/>
                    </article>

                    <div className="input-line-general">
                        <label for="description">Descripcion Principal</label>
                        <textarea type="text" name="description" id="description" placeholder="" disabled={estado}/>
                    </div>
                    
                </section>

                <section>
                    <img src={img5} alt="" />
                </section>
                
            </div>
        </>
    )
}

export default GeneralInfo;
